import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 mx-4 md:mx-6 lg:mx-10 mb-6 rounded-2xl overflow-hidden">
      <div className="px-6 md:px-10 lg:px-16 py-14">
        <div className="flex flex-col md:flex-row items-start justify-between mb-12">
          <div className="flex items-center gap-3">
            <span className="text-xl font-bold font-heading">韩漫大全</span>
          </div>
          <p className="text-foreground-300 text-sm mt-3 md:mt-0 max-w-md">
            韩国漫画免费阅读第一站，每日更新热门韩漫
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/love" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">恋爱漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">奇幻漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">动作漫画</Link>
              <Link to="/category/comedy" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">喜剧漫画</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              帮助中心
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/thriller" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">惊悚漫画</Link>
              <Link to="/category/daily" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">日常漫画</Link>
              <a href="#" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">阅读指南</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">常见问题</a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">联系方式</Link>
              <a href="#" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors" rel="nofollow">加入我们</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors" rel="nofollow">广告合作</a>
            </div>
          </div>
          <div className="text-right">
            <p className="text-lg font-serif text-background-50 mb-2">&copy; 韩漫大全 2026</p>
            <p className="text-xs text-foreground-300 mb-4">All rights reserved</p>
            <div className="flex justify-end gap-3">
              <Link to="/" className="text-foreground-300 hover:text-accent-400 transition-colors underline text-xs">首页</Link>
              <Link to="/about" className="text-foreground-300 hover:text-accent-400 transition-colors underline text-xs">关于</Link>
              <Link to="/category/love" className="text-foreground-300 hover:text-accent-400 transition-colors underline text-xs">热门</Link>
              <Link to="/category/fantasy" className="text-foreground-300 hover:text-accent-400 transition-colors underline text-xs">专题</Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-8 items-stretch">
          <div className="w-full md:w-2/5 h-48 rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20tablet%20displaying%20Korean%20webtoon%2C%20warm%20ambient%20lighting%2C%20bookshelf%20background%2C%20minimal%20interior%2C%20comfortable%20atmosphere%2C%20editorial%20photography%2C%20soft%20shadows&width=800&height=400&seq=hanman-footer-reading&orientation=landscape"
              alt="韩漫阅读场景"
              title="韩漫大全 韩国漫画免费阅读"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex items-center">
            <div className="font-serif text-2xl md:text-3xl text-background-50/80 leading-relaxed">
              <p>精选韩漫</p>
              <p>每日更新</p>
              <p>永久免费</p>
            </div>
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <p className="text-sm text-foreground-300 mb-3">
              订阅获取最新韩漫资讯，抢先了解热门作品更新动态
            </p>
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
              className="flex flex-col sm:flex-row gap-2"
              id="newsletter-form"
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                className="flex-1 bg-transparent border border-foreground-500 rounded-full px-4 py-2.5 text-sm text-background-50 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <button type="submit" className="whitespace-nowrap cursor-pointer bg-accent-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors flex items-center gap-1">
                订阅 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Schema.org structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫大全',
            url: 'http://wiiohv.cn/',
            description: '韩国漫画免费阅读第一站，每日更新热门韩漫',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'hello@wiiohv.cn',
              telephone: '400-888-6666',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '北京市',
              addressCountry: 'CN',
            },
          }),
        }}
      />
    </footer>
  );
}
